<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New product</div>
            <fieldset class="border p-2">
              <div>
                <form @submit.prevent="newProduct()">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Product name</label>
                        <input
                          type="text"
                          class="form-control product_name input_rounded"
                          placeholder="product name"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Product measurement</label>
                        <select
                          name="product_measurement"
                          class="form-control input_rounded product_measurement"
                        >
                          <option value>Select Measurement</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="PCS">PIECES</option>
                          <option value="LTS">LITRES</option>
                          <option value="SET">SET</option>
                          <option value="PAIR">PAIR</option>
                          <option value="MTR">METRES</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Selling price</label>
                        <input
                          readonly
                          type="number"
                          id="selling_price"
                          class="form-control selling_price input_rounded"
                          placeholder="selling price"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Product description</label>
                        <textarea
                          class="form-control product_description input_rounded"
                          placeholder="product description"
                          required
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label>Buying price</label>
                        <input
                          type="number"
                          id="buying_price"
                          class="form-control buying_price input_rounded"
                          placeholder="buying price"
                          required
                          @keyup="calculatePrice()"
                        />
                      </div>
                      <div class="form-group">
                        <label>Minimum Stock level </label>
                        <input
                          type="number"
                          class="form-control minimum_stock_level"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat btn-rounded creatingProduct"
                  >
                    <i class="fa fa-plus"></i> create product
                  </button>
                  <button
                    type="button"
                    class="btn btn-info btn-flat btn-rounded creatingProductLoader"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
export default {
  created() {
    this.loadProductnumber();
  },
  methods: {
    ...mapActions(["newProduct", "loadProductnumber"]),

    calculatePrice() {
      var buying_price = document.getElementById("buying_price").value;
      var buying_price = parseFloat(buying_price);
      var percentage = parseFloat(1.15);
      var selling_price = parseFloat(buying_price) * parseFloat(1.15);
      document.getElementById("selling_price").value = selling_price.toFixed(2);
    },
  },
  computed: {
    ...mapGetters(["Productnumber"]),
  },
};
</script>
<style scoped>
.creatingProductLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/products/product.vue